import { render, staticRenderFns } from "./ConsultaPlanoPJ.vue?vue&type=template&id=bfa939f4&"
import script from "./ConsultaPlanoPJ.vue?vue&type=script&lang=js&"
export * from "./ConsultaPlanoPJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports